if(document.querySelector('.main-nav-steps')){
    const getStepsList = Array.from(document.querySelectorAll('[id]')).filter(function(element) {
        return element.id.includes('step');
    });
    let mainNavSteps = document.querySelector('.main-nav-steps');
    let createNav = document.createElement('nav');
    createNav.id = 'main-nav';
    createNav.classList.add('navigation');

    getStepsList.forEach((el, index) =>{
        let createDiv = document.createElement('div');
        let createA = document.createElement('a');
        createNav.appendChild(createDiv);
        createDiv.classList.add('div-step');
        if(index === 0){
            createDiv.classList.add('active');
        }

        createA.href = '#'+el.getAttribute('id');
        createA.classList.add('step-link');
        createA.innerHTML += `<div class="step-number">${index+1}</div>`;
        createA.innerHTML += `<div class="step-text">${el.getAttribute('titlesteps')}</div>`;
        createDiv.appendChild(createA);
    });
    mainNavSteps.appendChild(createNav);

    let navbar = document.getElementById("main-nav");
    let navPos = navbar.getBoundingClientRect().top;

// Add an event listener listening for scroll
    window.addEventListener("scroll", navHighlighter);

    function navHighlighter() {
        let scrollY = window.scrollY;

        if (scrollY > navPos) {
            navbar.classList.add('sticky');
        }
        else {
            navbar.classList.remove('sticky');
        }
        if(scrollY < 100) {
            navbar.classList.remove('sticky');
        }

        getStepsList.forEach(current => {
            const sectionHeight = current.offsetHeight;
            const sectionTop = current.offsetTop - 50;
            let sectionId = current.getAttribute("id");

            if (
                scrollY > sectionTop &&
                scrollY <= sectionTop + sectionHeight
            ){
                document.querySelector(".navigation a[href*=" + sectionId + "]").parentElement.classList.add("active");
            } else {
                document.querySelector(".navigation a[href*=" + sectionId + "]").parentElement.classList.remove("active");
            }
        });
    }
}
